import { render, staticRenderFns } from "./CoozzyThLargeIcon.vue?vue&type=template&id=ab958f12&scoped=true"
import script from "./CoozzyThLargeIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyThLargeIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyThLargeIcon.vue?vue&type=style&index=0&id=ab958f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab958f12",
  null
  
)

export default component.exports